import { BasicUserResourceModel } from '@/modules/user/models/user-resource.model'
import { Data } from '@/modules/shared/models/data'
import { InvoiceItemResourceModel } from '@/modules/invoice-item/models/invoice-item-resource.model'
import {
  BillingInfoResourceModel,
  BillingInfoSwitchResourceModel
} from '@/modules/billing-info/models/billing-info-resource'
import { OwnBankInfoModel } from '@/modules/transaction/models/payment.model'

export enum InvoiceStatus {
  PAID = 'paid',
  UNPAID = 'unpaid',
  PENDING = 'pending',
  CANCELLED = 'cancelled'
}

export enum InvoiceModelType {
  CONTENT_CAMPAIGN = 'ContentCampaign',
  CUSTOM = 'Custom',
  MANUAL = 'Manual',
}

export enum InvoicePersonType {
  LEGAL = 'legal',
  NATURAL = 'natural',
}

export interface InvoiceResourceModel {
  id: number
  title: string
  description
  amount: number
  discount: number
  tax: number
  net_payable: number
  payable: number
  status: InvoiceStatus
  status_persian_name: string
  model_type: InvoiceModelType
  model_id: number
  created_at: string
  due_date: string
  paid_at: string
  person_type: InvoicePersonType
  billing_info: BillingInfoSwitchResourceModel
  create_by_admin: boolean,
  items: InvoiceItemResourceModel[]
}

export interface InvoicePaymentResourceModel {
  id: number,
  title: string,
  due_date: string,
  amount: number,
  discount: number,
  tax: number,
  net_payable: number,
  payable: number,
  billing_info: BillingInfoResourceModel,
  own_bank_info: OwnBankInfoModel
}

export interface InvoiceResourceModelInAdmin extends InvoiceResourceModel {
  user: BasicUserResourceModel
  profit: number
}

export interface InvoiceResourceWithModelInAdmin {
  statuses: { [key in InvoiceStatus]: string }
  person_types: { [key in InvoicePersonType]: string }
  model_types: { [key in InvoiceModelType]: string }
}

export type InvoiceResourceTypeInAdmin = Data<InvoiceResourceModelInAdmin> & InvoiceResourceWithModelInAdmin
